import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import EventListMarketsSection from './_event-list-markets-section.js'
import Dropdown from './_dropdown.js'
import MenuRow from './_menu-row.js'
import Image from './_image.js'

export default {
  name: 'EventListHeader',
  values: {
    showTitle: true,
    _mobile_showTitle: false,
    showMarketSelectors: true,
    showGameLineSwitcher: true,
    disableMarketHeader: false,
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '8px',
          boxSizing: 'border-box',
          _mobile_padding: '0px 8px 8px 8px',
          _mobile_flexDirection: 'row',
          justifyContent: 'flex-end',
        },
      },
    },
    title: {
      configSet: Text,
      configValues: {
        container: {
          _mobile_padding: '8px',
          display: 'flex',
          alignItems: 'center',
        },
      },
    },
    marketOptionsContainer: {
      configSet: EventListMarketsSection,
      configValues: {
        container: {
          style: {
            _mobile_display: 'block',
            _mobile_minWidth: 'auto',
            justifyContent: 'flex-start',
            flexGrow: 0,
          },
        },
        sportWidthOverride: undefined,
      },
    },
    forceMarketSwitcher: undefined,
    marketSwitcher: {
      configSet: Dropdown,
      configValues: {
        menuItemText: {
          truncate: true,
          ellipsisOnLineNumber: 2,
          style: {
            textAlign: 'end',
          },
        },
        menuContainer: {
          style: {
            right: '0px',
            left: 'auto',
            minWidth: '104px',
            maxWidth: '184px',
          },
        },
        itemsContainer: {
          style: {
            visible: {
              overflow: 'hidden',
            },
          },
        },
        controlButton: {
          style: {
            base: {
              _mobile_borderStyle: 'none',
              _mobile_flexGrow: 0,
              _mobile_maxWidth: '184px',
              minWidth: 'auto',
              maxWidth: '220px',
            },
          },
        },
        style: {
          rootContainer: {
            flexShrink: 0,
            _desktop_flexBasis: 0,
            _mobile_borderStyle: 'none',
            justifyContent: 'flex-end',
          },
        },
      },
    },
    gameLineSwitcher: {
      configSet: MenuRow,
      configValues: {
        style: {
          container: {
            width: 'auto',
          },
        },
        item: {
          unselected: {
            style: {
              base: {
                flexGrow: 0,
                minWidth: '80px',
              },
            },
          },
          selected: {
            style: {
              base: {
                flexGrow: 0,
                minWidth: '80px',
              },
            },
          },
        },
      },
    },
    marketHeader: {
      configSet: Text,
      configValues: {
        truncate: true,
        container: {
          flexBasis: '0px',
          padding: '0 8px',
        },
        style: {
          _desktop_textAlign: 'center',
          _mobile_textAlign: 'end',
        },
      },
    },
    sortEventsText: {
      configSet: Text,
      configValues: {
        container: {
          alignContent: 'center',
        },
      },
    },
    sortingIcon: {
      configSet: Image,
      configValues: {
        src: 'sort',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    sortingButtonContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          padding: '8px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
